







//import { ResponseModel } from "@dataSource/models/responseModels.ts";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({ name: "ui-dropdown-menu-sub"})
export default class UiDropdownMenuSubComponent extends Vue {
 @Prop({default:20})
 margin:number
 
 direction:string = "right"
 


 innerShow:boolean = false;

 show(e: MouseEvent){
    this.innerShow = true;
    this.$nextTick(() => {
      this.direction = e.screenX + 2*this.$el.clientWidth + this.margin > window.innerWidth ? "left": "right";
      // console.log(e.screenX , this.$el.clientWidth)
    })
    
 }
 
 hide(){
    this.innerShow = false
 }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/dropdown-menu/src/ui-dropdown-menu-sub.vue